import slice from './slice'

export * as selectors from './selectors'
export * as thunks from './thunks'

export const { reducer, actions } = slice
